import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { person } from "../../store/person/actions";
export var GetAllPerson = function (trigger) {
    var dispatch = useDispatch();
    var enable = React.useState(true)[0];
    var page = React.useState(1)[0];
    var limit = React.useState(100000)[0];
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responsePerson: (_a = state.Person.responsePerson) === null || _a === void 0 ? void 0 : _a.data,
            errorPerson: state.Person.errorPerson,
            loadingPerson: state.Person.loadingPerson,
        });
    }), responsePerson = _a.responsePerson, errorPerson = _a.errorPerson, loadingPerson = _a.loadingPerson;
    useEffect(function () {
        if (trigger) {
            dispatch(person({
                enable: enable,
                page: page,
                limit: limit,
            }));
        }
    }, [trigger]);
    return {
        responsePerson: responsePerson,
        errorPerson: errorPerson,
        loadingPerson: loadingPerson,
    };
};
